import { Text } from "pixi.js";
import { Text as TextEntity } from './Text'
import { TYPES } from "../../EntityManager";
import { graphic } from "../../Graphic";
import { EntityService } from "../EntityService";
import { graphicEvents, REMOVE_ENTITIES, UNSELECT_ENTITIES } from "../../GraphicEvents";

export class TextService extends EntityService {

    static upsertFromProps(textsProps) {
        super.upsertFromProps(TYPES.TEXT, textsProps);
    }

    static createFromProps(props) {
        const { id, container } = super.createFromProps(props);
        let { label, fontSize = 30 } = props;

        const graphicItem = new Text(label, {
            fontSize: !parseInt(fontSize) ? 30 : parseInt(fontSize)
        });

        let originalLabel = null;
        if (props.description) {
            originalLabel = label;
            label = props.description.text;
        }

        return new TextEntity({
            id,
            originalLabel,
            label,
            container,
            description: props.description,
            graphicItem
        });
    }

    static changeFontSize({ textsIds, value }) {
        textsIds.forEach(textId =>
            graphic.entityManager.get(TYPES.TEXT, textId).fontSize = value
        );
    }

    static changeLabel({ textsIds, value }) {
        textsIds.forEach(textId =>
            graphic.entityManager.get(TYPES.TEXT, textId).label = value
        );
    }

    static removeEmpty(entities) {
        return entities.filter((results, entity) => {
            if (entity instanceof TextEntity && entity.graphicItems[0].text.trim() === '') {
                graphicEvents.trigger(UNSELECT_ENTITIES, { entities: [entity],  remove: true });
                graphicEvents.trigger(REMOVE_ENTITIES, [entity]);
                return false;
            }
            return true;
        });
    }
}